import React, { useEffect, useState, useRef } from 'react';
import { useCarNameLabel } from '../../../../utils/carNames';
import CallLink from '../../../common/CallLink';

import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Constant from '../../../../Constant';
import moment from 'moment';
import {
  gettingUserCarDetails,
  saveAItem,
  removeSavedItem,
  getSavedItems,
  addToRecentlyViewed,
} from '../../../../Redux/Actions/UserAction';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { findSavedItemId } from '../../../../utils/savedItems';

const defaultImages = [
  {
    original: 'assets/images/service-provider/car-sale/car.jpg',
    thumbnail: 'assets/images/service-provider/car-sale/car.jpg',
  },
];

export default function CarForSaleDetail() {
  // [CF] Lets a tap on the banner open the gallery full-screen.
  const galleryRef = useRef(null);
  const params = useParams();
  const { carUUID } = params;

  const { t, i18n } = useTranslation();
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  /* [CF 2026-08-17 #11.1] The model is free text with no Arabic on the
     row; look it up from the model master. See utils/carNames.js */
  const nameLabel = useCarNameLabel(isRTL);
  // English in English mode, Arabic in Arabic mode (fallback to whichever exists).
  const L = (en, ar) => (isRTL ? ar || en : en || ar);
  const getTextAlign = () => (isRTL ? 'right' : 'left');

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(gettingUserCarDetails(carUUID));
    dispatch(getSavedItems());
    // Track this car as recently viewed
    dispatch(addToRecentlyViewed({ carSaleId: carUUID, type: 'CAR_SALE' }));
  }, [carUUID, dispatch]);

  const detail = useSelector((state) => state.home.carDetail);
  const carDetail = detail?.data[0];
  const savedItemsList = useSelector((state) => state?.home?.savedItemsList);

  // Fill the heart when the car is already saved (or once the user saves it).
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    if (carDetail) setSaved(!!carDetail.is_saved);
  }, [carDetail?.carSaleId, carDetail?.is_saved]);

  console.log('data', carDetail);

  // Process images for the gallery
  let galleryImages = defaultImages;

  if (carDetail?.businessMedia && carDetail.businessMedia.length > 0) {
    const mediaImages = carDetail.businessMedia
      .filter(
        (mediaItem) =>
          // Accept legacy banner spellings (MAIN_BANNER/BANNER) AND the
          // CAR_IMAGE type the add/edit form actually saves — otherwise newly
          // posted cars show no photos on their detail page.
          mediaItem?.media?.path &&
          [
            'MAIN_BANNER',
            'BANNER',
            'CAR_IMAGE',
            'CAR_IMAGES',
            'CAR-IMAGES',
            'CAR-IMAGE',
            'IMAGES',
          ].includes(mediaItem.mediaType)
      )
      .sort(
        (a, b) =>
          (a.mediaType === 'MAIN_BANNER' ? 0 : 1) -
          (b.mediaType === 'MAIN_BANNER' ? 0 : 1)
      )
      .map((mediaItem) => ({
        original: mediaItem.media.path,
        thumbnail: mediaItem.media.path,
      }));

    if (mediaImages.length > 0) {
      galleryImages = mediaImages;
    }
  }

  //POST TIME
  const formatPostedDate = (dateString) => {
    const date = moment(dateString);
    const now = moment();

    if (date.isSame(now, 'day')) {
      return 'Posted Today';
    } else if (date.isSame(now.clone().subtract(1, 'days'), 'day')) {
      return 'Posted Yesterday';
    } else {
      // [CF] Client: show the DATE only, no time.
      return `Posted on ${date.format('MMM D, YYYY')}`;
    }
  };

  const onHandleSave = () => {
    // Check if user is logged in
    const isLoggedIn = sessionStorage.getItem('loged_In') === 'true';

    if (!isLoggedIn) {
      Swal.fire({
        title: 'Please Login to Save',
        text: 'You need to be logged in to save this car. Please login first.',
        icon: 'warning',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Login',
        showCancelButton: true,
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          // Redirect to login page
          window.location.href = '#/login';
        }
      });
      return;
    }

    // User is logged in — optimistic toggle, no reload.
    const id = carDetail?.carSaleId;
    if (saved) {
      setSaved(false);
      const savedItemId =
        carDetail?.savedItemId || findSavedItemId(savedItemsList, id);
      if (savedItemId) dispatch(removeSavedItem({ savedItemId }));
    } else {
      setSaved(true);
      dispatch(saveAItem({ carSaleId: id }));
    }
  };

  // Share = copy the page link (or native share sheet). Users paste it into
  // whatever app they like — no in-app social modal.
  const handleShareClick = (e) => {
    if (e) e.preventDefault();
    const url = window.location.href;
    const title =
      L(carDetail?.brand?.name, carDetail?.brand?.nameAr) ||
      carDetail?.carModel ||
      'CarsAvenue';
    if (navigator.share) {
      navigator.share({ title, url }).catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard
        .writeText(url)
        .then(() =>
          Swal.fire({ title: 'Link copied to clipboard', icon: 'success' })
        )
        .catch(() =>
          Swal.fire({ title: 'Copy this link', text: url, icon: 'info' })
        );
    } else {
      Swal.fire({ title: 'Copy this link', text: url, icon: 'info' });
    }
  };

  return (
    <div>
      <div className="main-content-area">
        <div className="container">
          {/* [CF] mb-5 (48px) left a large empty band before the
                Specifications section — trimmed to mb-3. */}
          <div className="row mb-3">
            <div className="col-12 col-sm-12 col-md-6 col-lg-7 mb-2 mb-sm-2 mb-md-2 mb-lg-0">
              <div className="bxslider cav-car-gallery">
                <ImageGallery
                        ref={galleryRef}
                  items={galleryImages}
                  className="img-fluid"
                  infinite={true}
                  showNav={false}
                  showFullscreenButton={false}
                        // [CF] Client: tapping the banner opens the full view.
                        onClick={() => galleryRef.current?.fullScreen()}
                        useBrowserFullscreen={false}
                  showPlayButton={false}
                  showBullets={true}
                  slideInterval={3000}
                  onErrorImageURL="assets/images/service-provider/car-sale/car.jpg"
                />
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-6 col-lg-5 flex align-items-start">
              <div
                className="sidebar-box"
                id="sticky-box"
                style={{ position: 'sticky', top: '16px', alignSelf: 'flex-start' }}
              >
                {/* [CF] Posted date and Save/Share share ONE row (client: move
                    share and save up). space-between keeps them on opposite
                    edges, which mirrors correctly in Arabic. */}
                <div
                  className="mb-2"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    // [CF 2026-08-02] Save/Share must sit on the LEFT and the posted date
                    // on the RIGHT in BOTH languages. `space-between` alone mirrors with
                    // the page, so in Arabic they swapped sides; row-reverse in RTL flips
                    // the main axis back so the physical placement is language-independent.
                    flexDirection: isRTL ? 'row-reverse' : 'row',
                    gap: '16px',
                    flexWrap: 'wrap',
                  }}
                >
                  <div
                    className="save-share"
                    style={{ display: 'flex', alignItems: 'center', gap: '18px', flexShrink: 0 }}
                  >
                    <span onClick={onHandleSave} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                      <i
                        className={saved ? 'fas fa-heart' : 'far fa-heart'}
                        style={{ color: saved ? '#FEBA00' : 'inherit' }}
                      ></i>{' '}
                      {t('Save')}
                    </span>
                    <span onClick={handleShareClick} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                      <i className="far fa-share-square"></i> {t('Share')}
                    </span>
                  </div>
                  <p className="mb-0" style={{ textAlign: getTextAlign() }}>
                    <small>
                      <i className="far fa-calendar-alt"></i>{' '}
                      {carDetail?.createdAt &&
                        formatPostedDate(carDetail.createdAt)}
                    </small>
                  </p>
                </div>

                {/* [CF] Brand and model now sit on ONE line, so the price takes
                    the line the model used to occupy. */}
                <div
                  className="mb-2"
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    justifyContent: 'space-between',
                    gap: '16px',
                    flexWrap: 'wrap',
                  }}
                >
                  <h3 className="mb-0" style={{ textAlign: getTextAlign() }}>
                    {L(carDetail?.brand?.name, carDetail?.brand?.nameAr) || ''}
                  </h3>
                  <p className="mb-0" style={{ textAlign: getTextAlign() }}>
                    {nameLabel(carDetail?.carModel) || ''}
                  </p>
                </div>

                <h4 className="mb-4" style={{ color: '#FEBA00', textAlign: getTextAlign() }}>
                  KD {carDetail?.price || ''}
                </h4>

                {/* #17 — original-HTML horizontal stat bar (dark rounded pill):
                    Year | Color | Km | Cylinder. DOM order matches the original
                    template and renders right-to-left correctly in Arabic. */}
                <div className="car-details-block">
                  <div className="row">
                    <div className="col-3">
                      <div className="line-a">{t('Year')}</div>
                      <div className="line-b">
                        {carDetail?.modelYear?.modelYear || 'N/A'}
                      </div>
                    </div>
                    {/* [FB2-#15] Only show Color when one is actually set. */}
                    {(carDetail?.exteriorColor?.color ||
                      carDetail?.exteriorColor?.colorAr) && (
                      <div className="col-3">
                        <div className="line-a">{t('Color')}</div>
                        <div className="line-b">
                          {L(
                            carDetail?.exteriorColor?.color,
                            carDetail?.exteriorColor?.colorAr
                          )}
                        </div>
                      </div>
                    )}
                    <div className="col-3">
                      <div className="line-a">{t('Km')}</div>
                      <div className="line-b">
                        {carDetail?.kilometerDriven || 'N/A'}
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="line-a">{t('Cylinder')}</div>
                      <div className="line-b">
                        {carDetail?.cyclinder?.cyclinder || 'N/A'}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="car-agent-cwm" style={{ marginTop: '20px' }}>
                  <div className="row">
                    <div className="col-6">
                      <CallLink
                        record={carDetail}
                        className="btn btn-outline-secondary btn-block"
                        style={{ padding: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                      >
                        <img
                          src="assets/images/icons/user/car-dealers/telephone.svg"
                          alt="Call"
                          className="icon-cwm"
                          style={{ width: '20px', height: '20px' }}
                        />
                        <span>{t('Call')}</span>
                      </CallLink>
                    </div>

                    <div className="col-6">
                      <a
                        className="btn btn-outline-secondary btn-block"
                        target="_blank"
                        rel="noreferrer"
                        href={`https://wa.me/${`${carDetail?.whatsAppNumberCountryCode || ''}${carDetail?.whatsAppNumber || ''}`.replace(/\D/g, '')}`}
                        style={{ padding: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                      >
                        <img
                          src="assets/images/icons/user/car-dealers/whatsapp.svg"
                          alt="WhatsApp"
                          className="icon-cwm"
                          style={{ width: '20px', height: '20px' }}
                        />
                        <span>{t('WhatsApp')}</span>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="cav-car-desc">
                  {(
                    carDetail?.description ||
                    'No description available for this vehicle.'
                  )
                    .split(/\r?\n|(?=✅)|(?=✔️)|(?=✈️)|(?=•)/)
                    .map((line) => line.trim())
                    .filter(Boolean)
                    .map((line, idx) => (
                      <div className="cav-car-desc-line" key={idx}>
                        {line}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>

          {/* [CF-11] Specifications now sits BELOW the description (per client),
              full-width under the gallery/sidebar row. */}
          <div className="row">
            <div className="col-12">
              <h5 className="cav-section-title">{t('Specifications')}</h5>
              <table
                className="table table-bordered table-striped"
                style={{ textAlign: isRTL ? 'right' : 'left' }}
              >
                <tbody>
                  {/* [FB2-#15] Hide the Interior Color row when none is set. */}
                  {(carDetail?.interiorColor?.color ||
                    carDetail?.interiorColor?.colorAr) && (
                    <tr>
                      <td style={{ textAlign: getTextAlign() }}>{t('Interior Color')}</td>
                      <td style={{ textAlign: getTextAlign() }}>{L(carDetail?.interiorColor?.color, carDetail?.interiorColor?.colorAr)}</td>
                    </tr>
                  )}
                  <tr>
                    <td style={{ textAlign: getTextAlign() }}>{t('Seats')}</td>
                    <td style={{ textAlign: getTextAlign() }}>{carDetail?.seats?.seat || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: getTextAlign() }}>{t('Fuel Type')}</td>
                    <td style={{ textAlign: getTextAlign() }}>{L(carDetail?.fuelType?.fuelType, carDetail?.fuelType?.fuelTypeAr) || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: getTextAlign() }}>{t('Door')}</td>
                    <td style={{ textAlign: getTextAlign() }}>{carDetail?.doors?.door || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: getTextAlign() }}>{t('Comforts')}</td>
                    <td style={{ textAlign: getTextAlign() }}>
                      {(carDetail?.comfortId || [])
                        .map((comfort) => L(comfort?.comfort, comfort?.comfortAr))
                        .filter(Boolean)
                        .join(', ') || 'N/A'}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: getTextAlign() }}>{t('Safety')}</td>
                    <td style={{ textAlign: getTextAlign() }}>
                      {(carDetail?.safetyId || [])
                        .map((safety) => L(safety?.safety, safety?.safetyAr))
                        .filter(Boolean)
                        .join(', ') || 'N/A'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
